import { SENTRY_AREA_TAG, resolveSentryArea } from '@/sentry/sentry-areas';
import * as Sentry from '@sentry/react';
import { useLocation } from 'react-router-dom';

export const AppSentryArea = (): null => {
  const { pathname } = useLocation();

  Sentry.setTag(SENTRY_AREA_TAG, resolveSentryArea(pathname));

  return null;
};
